import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

export const UNSCHEDULE_ENVELOPE_QUERY_KEYS = [
  'envelopes',
  'envelope',
  'vault-items',
]

export const unscheduleEnvelope = async (envelopeId: string): Promise<void> => {
  await apiClient.post(`/v1/ecm/envelopes/${envelopeId}/unschedule`)
}

export const useUnscheduleEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (envelopeId: string) => unscheduleEnvelope(envelopeId),
    meta: {
      invalidatesQuery: UNSCHEDULE_ENVELOPE_QUERY_KEYS,
      ...feedback,
    },
  })
}
